export default [
  {
    path: "/orderPay", // 新闻列表
    name: "orderPay",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/OrderPay/index.vue"),
  },
];
